var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Cam__Icn/40px/Cam",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Cam__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Cam__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Cam__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Cam__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17,10 C17.5522847,10 18,10.4477153 18,11 L18,12 L29,12 C30.0543618,12 30.9181651,12.8158778 30.9945143,13.8507377 L31,14 L31,26 C31,27.1045695 30.1045695,28 29,28 L11,28 C9.8954305,28 9,27.1045695 9,26 L9,14 C9,12.8954305 9.8954305,12 11,12 L13,12 L13,11 C13,10.4871642 13.3860402,10.0644928 13.8833789,10.0067277 L14,10 Z M16,12 L15,12 L15,13 C15,13.5128358 14.6139598,13.9355072 14.1166211,13.9932723 L14,14 L11,14 L11,26 L29,26 L29,14 L17,14 C16.4477153,14 16,13.5522847 16,13 L16,12 Z M22,15 C24.7614237,15 27,17.2385763 27,20 C27,22.7614237 24.7614237,25 22,25 C19.2385763,25 17,22.7614237 17,20 C17,17.2385763 19.2385763,15 22,15 Z M22,17 C20.3431458,17 19,18.3431458 19,20 C19,21.6568542 20.3431458,23 22,23 C23.6568542,23 25,21.6568542 25,20 C25,18.3431458 23.6568542,17 22,17 Z",
    id: ".._.._src_svg_Icn_40px_Cam__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCam);
export default __webpack_public_path__ + "static/media/Cam.03f2bde78daa118fd5da5132edbc423f.svg";
export { ForwardRef as ReactComponent };